import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Button } from '@/shared/uikitV2/Button';

const MAX_LINES = 4;
const MAX_CHARS_PER_LINE = 40;
const MAX_CHARS_TOTAL = MAX_LINES * MAX_CHARS_PER_LINE;

type ExpandableTextProps = {
  text: string;
};

export const ExpandableText: FC<ExpandableTextProps> = ({ text }) => {
  const { t } = useTranslation('pages/pagePersonalIdentifierInfo');
  const [isExpanded, setIsExpanded] = useState(false);

  const lines = text.split('\n');
  const hasMoreLines = lines.length > MAX_LINES;
  const hasMoreChars = text.length > MAX_CHARS_TOTAL;
  const hasMore = hasMoreLines || hasMoreChars;

  const displayText = isExpanded
    ? text
    : hasMoreLines
    ? lines.slice(0, MAX_LINES).join('\n')
    : text.slice(0, MAX_CHARS_TOTAL);

  return (
    <div>
      <TextContent>{displayText}</TextContent>
      {hasMore && (
        <ShowAllButton type="text" onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? t('hide') : t('showAll')}
        </ShowAllButton>
      )}
    </div>
  );
};

const TextContent = styled.div`
  white-space: pre-wrap;
  word-break: break-word;
`;

const ShowAllButton = styled(Button)`
  &&& {
    color: ${COLORS.link};
    padding: 0;
    margin-top: 8px;
    height: auto;
    font-size: 14px;

    &:hover {
      color: ${COLORS.link};
      opacity: 0.8;
    }
  }
`;
